<template>
  <div class="text-h3">Sitio en construcción</div>
</template>

<script>

export default {
  name: 'planesView',

  data: () => ({
    //
  }),
};
</script>

<style>

</style>